import { useMutation, useQueryClient } from '@tanstack/react-query';
import QualCodeActions from 'actions/QualCodeActions';

/**
 * Hook for signing out the user
 * Clears the react-query cache after sign out to prevent stale data
 */
export function useSignOut() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: () => QualCodeActions.signOut(),
    onSettled: () => {
      // Clear all react-query cache after sign out (success or error)
      // This ensures no cached data persists between user sessions
      queryClient.clear();
    },
    retry: false,
  });
}